import { ArrowRight } from 'lucide-react';

export default function CTAFinal({ onEmpezar }) {
  return (
    <section className="py-20 md:py-24 bg-navy-950">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">
          Empieza hoy a ahorrar horas de trabajo.
        </h2>
        <p className="mt-4 text-lg text-slate-300">
          Prueba Conciliabanco y descubre cómo hacer conciliaciones bancarias en menos de un minuto.
        </p>
        <button
          onClick={onEmpezar}
          className="mt-9 inline-flex items-center gap-2 rounded-lg bg-brand-green px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-brand-greenDark hover:-translate-y-0.5 transition-all"
        >
          Empieza ahora <ArrowRight size={18} />
        </button>
      </div>
    </section>
  );
}
